var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[(_vm.listType)?_c('MomentItemFeed',{attrs:{"listType":_vm.listType}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }